<template>
    <footer class="footer">
        <button type="button" class="go-top" v-show="mainPage" @click="goTopBtn()">
            <img src="@/assets/resource/icon/top.png" alt="상단으로 이동">
        </button>

        <div class="footer__inner">
            <div class="footer__link">
                <p>Build your commerce platform with OSE - Commerce v.1.2.</p>
                <router-link :to="{ path: '/CustomerSupport', query: { name: 'inquiry' } }" class="header__btn-link">
                    <span>Business Inquiry</span>
                    <span><img src="@/assets/resource/icon/send_fill.png" alt=""></span>
                </router-link>
            </div>
            <div class="footer__info">
                <img src="@/assets/resource/icon/logo.svg" alt="">
                <p class="footer__address">
                    ADDRESS. 143, Gasan digital 2-ro, Geumcheon-gu, <br>
                    (Gasan Urban Work Building 2, Rooms 1211-1214) <br>
                    Seoul, Republic of Korea
                </p>
                <p class="footer__address-tel">
                    <span>TEL. +82-70-7772-7766</span>
                    <span>ⓒ OSANGTECH. all rights reserved.</span>
                </p>
            </div>
        </div>
    </footer>
</template>
<script>
    export default {
        data() {
            return {
                mainPage: '',
                observer: null,  // IntersectionObserver 객체를 저장할 변수
            };
        },
        methods: {
            goTopBtn() {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth', // 부드러운 스크롤
                });
            },
            observeFooter() {
                const footer = document.querySelector('.footer');
                const goTopButton = document.querySelector('.go-top');

                // IntersectionObserver 콜백 함수
                const callback = (entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            // footer가 뷰포트에 보이면 active 클래스 추가
                            goTopButton.classList.add('active');
                        } else {
                            // footer가 뷰포트에서 벗어나면 active 클래스 제거
                            goTopButton.classList.remove('active');
                        }
                    });
                };

                // IntersectionObserver 생성
                this.observer = new IntersectionObserver(callback, {
                    root: null, // 뷰포트를 기준으로 감지
                    threshold: 0.1, // footer의 10%가 보일 때 이벤트 트리거
                });

                // footer 요소를 감지 대상으로 설정
                this.observer.observe(footer);
            },
            goTop() {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            }
        },
        watch: {
            $route(to, from) {
                if (to.path !== from.path || JSON.stringify(to.query) !== JSON.stringify(from.query)) {
                    this.goTop();
                    document.querySelector(".go-top").classList.remove("active");
                }
                if (to.path === '/') {
                    this.mainPage = false;
                } else {
                    this.mainPage = true;
                }
            }
        },
        mounted() {
            if (this.$route.path === '/') {
                this.mainPage = true;
            } else {
                this.mainPage = false;
            }
            this.goTop();
            this.observeFooter();  // IntersectionObserver 시작
        },
        beforeDestroy() {
            if (this.observer) {
                this.observer.disconnect();  // 컴포넌트가 파괴되기 전에 observer 해제
            }
        }
    }
</script>


<style>

</style>